import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useMemo, useRef, useState } from "react"
import Modal from "react-modal"
import { Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./../ImageOpt"

const MenusDetails = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const [tabOption, setTabOption] = useState(module.menuTab[0].menuName)
  const categories = module.menuTab

  const imgCdn = (imgData, width, height) => {
    const img = `https://wsrv.nl/?url=${imgData}&w=${width}&h=${height}&output=webp`
    return img
  }

  const newCatarray = useMemo(() => {
    const catArray = {}
    for (var i = 0; i < categories.length; i++) {
      const slugCat = categories[i].menuName
      catArray[`${slugCat}`] = []
    }
    module.menuTab.forEach(item => {
      item.menuImages.forEach(img => {
        catArray[`${item.menuName}`].push(img)
      })
    })
    return catArray
  }, [categories])

  // another tab gallery lightbox images start
  const [isOpen, setIsOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [currentTab, setCurrentTab] = useState("")
  const openLightbox = (name, n) => {
    document.body.classList.add("modal-open")
    setIsOpen(true)
    setCurrentTab(name)
    setCurrentImageIndex(n)
  }
  const closeLightbox = () => {
    document.body.classList.remove("modal-open")
    setIsOpen(false)
  }
  const changeImage = (name, n) => {
    let newIndex = currentImageIndex + n
    if (newIndex < 0) {
      newIndex = newCatarray[name].length - 1
    } else if (newIndex >= newCatarray[name].length) {
      newIndex = 0
    }
    setCurrentImageIndex(newIndex)
  }
  // another tab gallery lightbox images end

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "0",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      backgroundColor: "black",
    },
    overlay: {
      zIndex: "99",
    },
  }

  if (module.hideSection === "no") {
    return (
      <>
        <section
          className={`menus-slider${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <div className="container-fluid">
            <div className="bg-white-100 py-60 lgscreen:py-30 pb-110 lgscreen:pb-30">
              <motion.div
                initial="hidden"
                animate={isInView || hasPlayed ? "show" : "hidden"}
                variants={sectionShow}
              >
                <motion.div
                  ref={ref}
                  initial="hidden"
                  animate={isInView || hasPlayed ? "show" : "hidden"}
                  variants={sectionShow}
                >
                  <div className="top-content relative w-full max-w-[960px] px-20 mx-auto text-center">
                    {module?.heading && (
                      <motion.h2 variants={animFade}>
                        {module.heading}
                      </motion.h2>
                    )}
                    {module?.description && (
                      <motion.div variants={animFade} className="content pb-30">
                        {parse(module.description)}
                      </motion.div>
                    )}
                  </div>
                  <div className="tabs-horizontal">
                    <motion.div variants={animFade}>
                      <ul className="tabs w-full flex flex-wrap justify-center mt-50 lgscreen:mt-30 gap-x-8 gap-y-5">
                        {module.menuTab.length > 0 &&
                          module.menuTab.map((item, i) => (
                            <li
                              key={i}
                              onClick={e => {
                                setTabOption(item.menuName)
                              }}
                              className={`tab-link cursor-pointer text-18 tracking-05em uppercase opacity-50  ${
                                tabOption === item.menuName ? "tab-current" : ""
                              }`}
                              onKeyDown={() => {
                                setTabOption(item.menuName)
                              }}
                              aria-hidden="true"
                            >
                              {item.menuName}
                            </li>
                          ))}
                      </ul>
                    </motion.div>
                  </div>
                  <div className="accordian-container mt-50 lgscreen:mt-25 px-80 lgscreen:px-40 mdscreen:px-20 relative">
                    {module?.menuTab &&
                      module.menuTab.map((item, i) => (
                        <>
                          <div
                            id={item.menuName}
                            className={`tab-content ${
                              tabOption === item.menuName
                                ? "tab-current"
                                : "hidden"
                            }`}
                            key={i}
                          >
                            <motion.div
                              variants={animFade}
                              className="relative"
                            >
                              {item?.menuImages.length > 1 && (
                                <Swiper
                                  spaceBetween={30}
                                  slidesPerView={"3"}
                                  speed={1000}
                                  pagination={{
                                    clickable: false,
                                  }}
                                  navigation={true}
                                  breakpoints={{
                                    0: {
                                      slidesPerView: 1,
                                    },
                                    641: {
                                      slidesPerView: 2,
                                    },
                                    1024: {
                                      slidesPerView: 3,
                                    },
                                  }}
                                  modules={[Navigation]}
                                  className={`tab-swiper-${i}`}
                                >
                                  {item?.menuImages &&
                                    item.menuImages.map((img, j) => (
                                      <SwiperSlide key={j}>
                                        <div
                                          onClick={() =>
                                            openLightbox(item.menuName, j)
                                          }
                                          onKeyDown={() =>
                                            openLightbox(item.menuName, j)
                                          }
                                          className="img relative menu-image hover:cursor-pointer"
                                        >
                                          <ImageOpt
                                            imgData={img.image?.mediaItemUrl}
                                            width={1400}
                                            height={1400}
                                            imgAlt={img.image?.altText}
                                            imgLoad="lazy"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ))}
                                </Swiper>
                              )}
                              {item?.menuImages.length < 2 && (
                                <div
                                  onClick={() => openLightbox(item.menuName, 0)}
                                  onKeyDown={() =>
                                    openLightbox(item.menuName, 0)
                                  }
                                  className="img hover:cursor-pointer relative h-[55vw] lgscreen:h-[70vw] mdscreen:h-[120vw]"
                                >
                                  <ImageOpt
                                    imgData={
                                      item?.menuImages[0].image?.mediaItemUrl
                                    }
                                    imgClass="!object-contain"
                                    width={1500}
                                    height={1000}
                                    imgAlt={item?.menuImages[0].image?.altText}
                                    imgLoad="lazy"
                                  />
                                </div>
                              )}
                            </motion.div>

                            <div className="flex flex-wrap justify-center gap-x-2 mt-80 lgscreen:mt-30 gap-y-2">
                              {item?.bookNow && (
                                <motion.div
                                  variants={animFade}
                                  className="smscreen:w-full"
                                >
                                  <Link
                                    to={item.bookNow.url}
                                    className="btn btn-black"
                                    target={item.bookNow.target}
                                  >
                                    {item.bookNow.title}
                                  </Link>
                                </motion.div>
                              )}
                              {item?.downloadMenu && (
                                <motion.div
                                  variants={animFade}
                                  className="smscreen:w-full"
                                >
                                  <Link
                                    to={item.downloadMenu.mediaItemUrl}
                                    target="_blank"
                                    className="btn btn-border flex flex-wrap items-center gap-x-1"
                                  >
                                    download menu

                                  </Link>
                                </motion.div>
                              )}
                            </div>
                          </div>
                          {isOpen && (
                            <Modal
                              isOpen={isOpen}
                              style={customStyles}
                              onRequestClose={closeLightbox}
                              contentLabel="Example Modal"
                              id={`${item.menuName}-gallery-images`}
                              ariaHideApp={false}
                            >
                              <div className="video-modal-popup h-full mdscreen:bg-[#fff]">
                                <button
                                  onClick={closeLightbox}
                                  onKeyDown={closeLightbox}
                                  aria-hidden="true"
                                  className="absolute z-999 right-50 top-50 lgscreen:right-20 mdscreen:top-20 bg-white-100 flex items-center justify-center w-[42px] h-[42px] rounded-100"
                                >
                                  <img
                                    src="../../../images/close.svg"
                                    className="absolute top-50per left-50per translate-x-minus_50 translate-y-minus_50"
                                    width={16}
                                    height={16}
                                    loading="lazy"
                                    alt="closebtn"
                                  />
                                </button>

                                <div className="flex flex-wrap items-center w-full h-full relative z-1">
                                  <div className="w-full h-full">
                                    <div className="modal-video h-full flex items-start">
                                      <img
                                        src={
                                          newCatarray[`${currentTab}`][
                                            currentImageIndex
                                          ]["image"]["mediaItemUrl"]
                                        }
                                        alt={
                                          newCatarray[`${currentTab}`][
                                            currentImageIndex
                                          ]["image"]["altText"]
                                        }
                                        className="h-full m-auto object-contain mdscreen:max-w-[320px]"
                                        width=""
                                        height=""
                                      />
                                      <div className="lightbox-navigation swiper-arrow arrow-big flex gap-x-5">
                                        <button
                                          className="absolute left-55 lgscreen:left-20 mdscreen:left-10 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                                          onClick={() =>
                                            changeImage(currentTab, -1)
                                          }
                                          onKeyDown={() => {
                                            changeImage(currentTab, -1)
                                          }}
                                          aria-hidden="true"
                                        >
                                          <img
                                            src="../../../images/slider-arrow.svg"
                                            width={42}
                                            height={42}
                                            loading="lazy"
                                            alt="Arrow"
                                          />
                                        </button>
                                        <button
                                          className="absolute right-55 lgscreen:right-20 mdscreen:right-10 top-50per translate-y-minus_50 z-9 transition-all duration-300 outline-none"
                                          onClick={() =>
                                            changeImage(currentTab, 1)
                                          }
                                          onKeyDown={() => {
                                            changeImage(currentTab, 1)
                                          }}
                                          aria-hidden="true"
                                        >
                                          <img
                                            src="../../../images/slider-arrow.svg"
                                            width={42}
                                            height={42}
                                            className="scale-x-[-1]"
                                            loading="lazy"
                                            alt="Arrow"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Modal>
                          )}
                        </>
                      ))}
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </section>
      </>
    )
  }
  return null
}

export default MenusDetails
export const EatDrinkMenusDetailsFragment = graphql`
  fragment EatDrinkMenusDetailsFragment on WpEatDrink_Restaurantcontent_RestaurantContent_MenusDetails {
    extraId
    extraClass
    hideSection
    heading
    description
    menuTab {
      menuName
      menuImages {
        image {
          altText
          mediaItemUrl
        }
      }
      downloadMenu {
        altText
        mediaItemUrl
      }
      bookNow {
        target
        title
        url
      }
    }
  }
`
